import GLOBAL from './GLOBAL';

/**
 * Return an object with width and height of a viewport
 *
 * @returns {object} {{width: number, height: number}}
 * @example
 * let size = getViewportSize();
 * console.log(size.width, size.height);
 */
const getViewportSize = () => {
  const win = GLOBAL.getWindow();
  const doc = GLOBAL.getDocument();
  const e = doc.documentElement;
  const g = doc.getElementsByTagName('body')[0];
  const x = win.innerWidth || e.clientWidth || g.clientWidth;
  const y = win.innerHeight || e.clientHeight || g.clientHeight;

  return {
    width: x,
    height: y,
  };
};

export default getViewportSize;
